<i18n>
{
  "cl": {
    "latestOperation": "Sólo operación más morosa",
    "fees": "Cuotas",
    "fee": "Cuota",
    "feeMore": "cuotas o más",
    "noRestriction": "Sin restricción",
    "days": "días",
    "more": "o más",
    "lateDays": "Días en mora",
    "mortgage": "Hipotecario",
    "parking": "Estacionamiento",
    "complementary": "Complementario",
    "SME": "SME",
    "DOWN_PAYMENT": "Pie",
    "FIRST_HOME": "Primera vivenda",
    "SUBSIDY": "Subsidio",
    "INVESTMENT": "Inversión",
    "HOME_EQUITY": "HOME_EQUITY",
    "PY": "PY",
    "ISIETE": "ISIETE",
    "SB2": "SB2",
    "MAESTRA": "MAESTRA",
    "ARMAS": "ARMAS",
    "CREDITU": "CREDITU"
  },
  "pe": {
    "latestOperation": "Sólo operación más morosa",
    "fees": "Cuotas",
    "fee": "Cuota",
    "feeMore": "Cuotas o más",
    "noRestriction": "Sin restricción",
    "days": "días",
    "more": "o más",
    "lateDays": "Días en mora",
    "mortgage": "Hipotecario",
    "parking": "Estacionamiento",
    "complementary": "Complementario",
    "SME": "SME",
    "DOWN_PAYMENT": "Pie",
    "FIRST_HOME": "Primera vivenda",
    "SUBSIDY": "Subsidio",
    "INVESTMENT": "Inversión",
    "HOME_EQUITY": "HOME_EQUITY",
    "PY": "PY",
    "ISIETE": "ISIETE",
    "SB2": "SB2",
    "MAESTRA": "MAESTRA",
    "ARMAS": "ARMAS",
    "CREDITU": "CREDITU"
  },
  "br": {
    "latestOperation": "Somente operação mais atrasada",
    "fees": "Parcelas",
    "fee": "Parcela",
    "feeMore": "Parcelas ou mais",
    "noRestriction": "Sem restrição",
    "days": "dias",
    "more": "ou mais",
    "lateDays": "Dias em atraso",
    "mortgage": "Hipoteca",
    "complementary": "Complementar",
    "parking": "Estacionamento",
    "SME": "SME",
    "DOWN_PAYMENT": "DOWN_PAYMENT",
    "FIRST_HOME": "Primeira casa",
    "SUBSIDY": "Subvenção",
    "INVESTMENT": "Investimento",
    "HOME_EQUITY": "HOME_EQUITY",
    "PY": "PY",
    "ISIETE": "ISIETE",
    "SB2": "SB2",
    "MAESTRA": "MAESTRA",
    "ARMAS": "ARMAS",
    "CREDITU": "CREDITU"
  }
}
</i18n>
<template>
  <b-modal id="filter-modal" v-model="auxValue.isModalVisible" :width="400">
    <div class="filter-modal modal-card-body has-text-centered">
      <div>
        <a class="close-modal" @click="auxValue.isModalVisible = false">
          <img src="@/ui/assets/img/plus-button.svg">
        </a>
      </div>
      <h3 class="modal-title">Filtros</h3>
      <div class="mb-2">
        <b-switch id="max-defaulting-fees" v-model="auxValue.useMaxDefaultingOperation" left-label class="pb-3"> {{ $t('latestOperation') }} </b-switch>
        <b-field horizontal label="Operación" custom-class="has-text-weight-normal">
          <b-select
            id="typeOperationToFilter"
            v-model="auxValue.typeOperation"
            expanded
            name="typeOperationToFilter"
            size="is-small"
            rounded>
            <option value="" selected>Elige tipo de operación</option>
            <option
              v-for="key in Object.keys(typeOperationToFilter[country]).sort()"
              :key="key"
              :value="key">
              {{ $t(typeOperationToFilter[country][key]) }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal label="Subtipo" custom-class="has-text-weight-normal">
          <b-select
            id="operationSubTypeToFilter"
            v-model="auxValue.operationSubType"
            expanded
            name="operationSubTypeToFilter"
            size="is-small"
            rounded>
            <option value="" selected>Elige subtipo de operación</option>
            <option
              v-for="key in Object.keys(operationSubTypeToFilter[country]).sort()"
              :key="key"
              :value="key">
              {{ $t(operationSubTypeToFilter[country][key]) }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal label="Origen" custom-class="has-text-weight-normal">
          <b-select
            id="operationOriginToFilter"
            v-model="auxValue.operationOrigin"
            expanded
            name="operationOriginToFilter"
            size="is-small"
            rounded>
            <option value="" selected>Elige origen de operación</option>
            <option
              v-for="key in Object.keys(operationOriginToFilter[country]).sort()"
              :key="key"
              :value="key">
              {{ $t(operationOriginToFilter[country][key]) }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal label="Inversionista" custom-class="has-text-weight-normal">
          <b-select
            id="operationInvestorToFilter"
            v-model="auxValue.operationInvestor"
            expanded
            name="operationInvestorToFilter"
            size="is-small"
            rounded>
            <option value="" selected>Elige inversionista de operación</option>
            <option
              v-for="(investor) in investors"
              :key="investor._id"
              :value="investor._id">
              {{ investor.name }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$t('fees')" custom-class="has-text-weight-normal">
          <b-select
            id="defaulting-payments"
            v-model="auxValue.defaultingPayments"
            expanded
            name="month"
            size="is-small"
            rounded>
            <option v-for="num in auxValue.numberOfDefaultingPaymentsOptions" :key="num" :value="num">
              {{
                num === 0 ?
                  $t('noRestriction') :
                  num !== auxValue.numberOfDefaultingPaymentsOptions[auxValue.numberOfDefaultingPaymentsOptions.length - 1] ?
                    `${num} ${$t('fee')}${num !==1 ? 's' : ''}` :
                    `${num} ${$t('feeMore')}`
              }}
            </option>
          </b-select>
        </b-field>
        <b-field horizontal :label="$t('lateDays')" custom-class="has-text-weight-normal">
          <b-select
            id="defaulting-days"
            v-model="auxValue.defaultingDays"
            expanded
            name="month"
            size="is-small"
            rounded>
            <option :value="[]">{{ $t('noRestriction') }}</option>
            <option :value="[1, 31]">1 a 30 {{ $t('days') }}</option>
            <option :value="[30, 61]">31 a 60 {{ $t('days') }}</option>
            <option :value="[60, 91]">61 a 90 {{ $t('days') }}</option>
            <option :value="[90, 121]">91 a 120 {{ $t('days') }}</option>
            <option :value="[120, 151]">121 a 150 {{ $t('days') }}</option>
            <option :value="[150, 181]">151 a 180 {{ $t('days') }}</option>
            <option :value="[180]">181 {{ $t('days') }} {{ $t('more') }}</option>
          </b-select>
        </b-field>
      </div>
      <div class="buttons is-centered mb-3 mt-3">
        <b-button
          id="restore-button"
          class="is-button-secondary"
          rounded
          size="is-small"
          icon-left="fas fa-undo-alt"
          @click="
            auxValue.typeOperation = '',
            auxValue.operationSubType = '',
            auxValue.operationOrigin = '',
            auxValue.operationInvestor = '',
            auxValue.defaultingDays = [],
            auxValue.defaultingPayments = 0
          ">
          Restaurar filtros
        </b-button>
        <b-button
          id="accept-button"
          class="is-button-secondary"
          rounded
          size="is-small"
          @click="auxValue.isModalVisible = false">
          Filtrar
        </b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getInvestors } from '@/application/services/api-clients/investors';

export default {
  props: ['value'],
  data() {
    return {
      investors: {},
      country: this.$i18n.locale,
      auxValue: {},
      typeOperationToFilter: {
        cl: {
          MORTGAGE: 'mortgage',
          COMPLEMENTARY: 'complementary',
          PARKING: 'parking',
          SME: 'SME'
          // HOME_EQUITY: 'HOME_EQUITY'
        },
        br: {
          MORTGAGE: 'mortgage',
          // COMPLEMENTARY: 'complementary',
          // PARKING: 'parking',
          // SME: 'SME',
          HOME_EQUITY: 'HOME_EQUITY'
        },
        pe: {
          MORTGAGE: 'mortgage',
          COMPLEMENTARY: 'complementary',
          PARKING: 'parking',
          SME: 'SME',
          HOME_EQUITY: 'HOME_EQUITY'
        }
      },
      operationSubTypeToFilter: {
        cl: {
          DOWN_PAYMENT: 'DOWN_PAYMENT',
          FIRST_HOME: 'FIRST_HOME',
          SUBSIDY: 'SUBSIDY',
          INVESTMENT: 'INVESTMENT'
        },
        br: {
          // DOWN_PAYMENT: 'DOWN_PAYMENT',
          FIRST_HOME: 'FIRST_HOME',
          SUBSIDY: 'SUBSIDY',
          INVESTMENT: 'INVESTMENT'
        },
        pe: {
          DOWN_PAYMENT: 'DOWN_PAYMENT',
          FIRST_HOME: 'FIRST_HOME',
          SUBSIDY: 'SUBSIDY',
          INVESTMENT: 'INVESTMENT'
        }
      },
      operationOriginToFilter: {
        cl: {
          PY: 'PY',
          ISIETE: 'ISIETE',
          SB2: 'SB2',
          CREDITU: 'CREDITU',
          ICUADRA: 'ICUADRA',
          MAESTRA: 'MAESTRA',
          ARMAS: 'ARMAS'
        },
        br: {
          // PY: 'PY',
          // ISIETE: 'ISIETE',
          // SB2: 'SB2',
          CREDITU: 'CREDITU'
        },
        pe: {
          // PY: 'PY',
          // ISIETE: 'ISIETE',
          // SB2: 'SB2',
          CREDITU: 'CREDITU'
        }
      }
    };
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.$store.state.filters = val;
        this.auxValue = val;
      }
    },
    auxValue: {
      deep: true,
      handler(val) {
        this.$store.state.filters = val;
        this.$emit('input', val);
      }
    }
  },
  async mounted() {
    this.investors = await getInvestors();
  }
};
</script>
<style scoped>
.close-modal {
  position: absolute;
  right: 20px;
  top:20px;
  width: 40px;
}
</style>
